import React from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { login } from '../../../../src/login/Actions';
import { addMenuItems } from '../../../../src/menu/Actions';
import Confirm from '../../../../src/confirm/Confirm';
import Message from '../../../../src/message/Message';
import Notice from '../../../../src/notice/Notice';
import Menu from '../../../../src/menu/MenuComplete';
import AlertConfirm from '../../../../src/alertConfirm/AlertConfirm';

let menuList = [];

menuList.push({url: '/mass', header: 'Massan lisäys'});
menuList.push({url: '/trucks', header: 'Rekat'});

class App extends React.Component {

  constructor(props) {
    super(props);

    localStorage.loadingSuccess = true;
    this.props.addMenuItems(menuList);

    this.path = this.props.location.pathname;
    this.login = false;
  }

  render() {
    if (this.props.user == null) {
      if (!this.login) {
        this.login = true;
        return <Navigate to='/login' push/>;
      }
    }
    else {
      /**
      if (!this.props.user.get('permissions').includes('Mass')) {
        this.props.login(null);
        this.props.showMessage('Virhe', 'Sinulla ei ole oikeuksia tähän ohjelmaan', 'Error');
        return null;
      }
      */

      if (!this.props.location.pathname.includes('/mass') &&
          !this.props.location.pathname.includes('/trucks') &&
          !this.props.location.pathname.includes('/trucks/new') &&
          !this.props.location.pathname.match('/truck/[1-9]d*')) {
        if (this.path !== this.props.location.pathname) {
          return <Navigate to={this.path} push/>;
        }
        return <Navigate to='/mass' push/>;
      }
    }

    return (
      <div>
        <Menu store={this.props.store} />
        <Message store={this.props.store} />
        <Notice store={this.props.store} />
        <Confirm store={this.props.store} />
        <AlertConfirm store={this.props.store} />
      </div>
    );
  }
}


export default connect(state => ({
  user: state.login.get('user'),
}), { login, addMenuItems })(App);
